import { fetcher, FetchError, useQuery } from '@oaknorth/util-rest';
import { useAccessToken } from '@oaknorth/util-user';

const PATH = '/api/polaris/api/foundations/rum/configuration';

type RUMSettings = {
  apiKey: string;
  url: string;
};

export function useRumConfig() {
  const accessToken = useAccessToken();

  const config = useQuery<RUMSettings, FetchError>({
    queryKey: [PATH],
    queryFn: () =>
      fetcher<RUMSettings>({
        url: PATH,
        headers: accessToken
          ? {
              // eslint-disable-next-line @oaknorth/ui/no-template-literals -- part of http request, not user facing
              authorization: `Bearer ${accessToken}`,
            }
          : undefined,
      }),
  });

  return config;
}
